// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file announcement/announcement.proto (package vsmr.announcement.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message vsmr.announcement.v1.Announcement
 */
export class Announcement extends Message<Announcement> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * 공지가 **알려진 순서**. 처음 게시할 때 매긴다.
   *
   * 한 번도 안 알린 초안은 번호가 없고 wire 로 0 이 나간다(화면은 번호 대신
   * "초안"을 보인다). **번호가 있다는 것이 곧 "알린 적이 있다"** 이고, 서버는
   * 그것으로 수정·삭제를 막는다 — `published` 가 아니라 이 값이 기준이다.
   *
   * 만든 순서로 매기면 초안을 먼저 만들어 두고 나중에 게시한 공지가
   * 안 읽은 수(number > last_read)에 영영 안 잡힌다.
   *
   * @generated from field: int64 number = 2;
   */
  number = protoInt64.zero;

  /**
   * @generated from field: string author_id = 3;
   */
  authorId = "";

  /**
   * user_profiles.display_name 조인 (표시용 — 빈 값 가능)
   *
   * @generated from field: string author_name = 4;
   */
  authorName = "";

  /**
   * @generated from field: string title = 5;
   */
  title = "";

  /**
   * 마크다운 본문
   *
   * @generated from field: string body = 6;
   */
  body = "";

  /**
   * false 면 초안 — admin 에게만 보인다
   *
   * @generated from field: bool published = 7;
   */
  published = false;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * 게시된 시각 — 초안이면 비어 있다
   *
   * @generated from field: google.protobuf.Timestamp published_at = 10;
   */
  publishedAt?: Timestamp;

  constructor(data?: PartialMessage<Announcement>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.Announcement";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "author_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "author_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "published", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
    { no: 9, name: "updated_at", kind: "message", T: Timestamp },
    { no: 10, name: "published_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Announcement {
    return new Announcement().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Announcement {
    return new Announcement().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Announcement {
    return new Announcement().fromJsonString(jsonString, options);
  }

  static equals(a: Announcement | PlainMessage<Announcement> | undefined, b: Announcement | PlainMessage<Announcement> | undefined): boolean {
    return proto3.util.equals(Announcement, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.ListAnnouncementsRequest
 */
export class ListAnnouncementsRequest extends Message<ListAnnouncementsRequest> {
  /**
   * admin 전용 — 초안까지 포함. 일반 사용자가 켜면 거절한다(조용한 축소 금지).
   *
   * @generated from field: bool include_drafts = 1;
   */
  includeDrafts = false;

  constructor(data?: PartialMessage<ListAnnouncementsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.ListAnnouncementsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "include_drafts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAnnouncementsRequest {
    return new ListAnnouncementsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAnnouncementsRequest {
    return new ListAnnouncementsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAnnouncementsRequest {
    return new ListAnnouncementsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAnnouncementsRequest | PlainMessage<ListAnnouncementsRequest> | undefined, b: ListAnnouncementsRequest | PlainMessage<ListAnnouncementsRequest> | undefined): boolean {
    return proto3.util.equals(ListAnnouncementsRequest, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.ListAnnouncementsResponse
 */
export class ListAnnouncementsResponse extends Message<ListAnnouncementsResponse> {
  /**
   * @generated from field: repeated vsmr.announcement.v1.Announcement announcements = 1;
   */
  announcements: Announcement[] = [];

  /**
   * 이 사용자가 읽은 마지막 번호 (0 = 없음)
   *
   * @generated from field: int64 last_read_number = 2;
   */
  lastReadNumber = protoInt64.zero;

  /**
   * 안 읽은 공지 수 — 배너가 세지 않는다. 초안은 세지 않는다.
   *
   * @generated from field: int32 unread_count = 3;
   */
  unreadCount = 0;

  constructor(data?: PartialMessage<ListAnnouncementsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.ListAnnouncementsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announcements", kind: "message", T: Announcement, repeated: true },
    { no: 2, name: "last_read_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "unread_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAnnouncementsResponse {
    return new ListAnnouncementsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAnnouncementsResponse {
    return new ListAnnouncementsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAnnouncementsResponse {
    return new ListAnnouncementsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAnnouncementsResponse | PlainMessage<ListAnnouncementsResponse> | undefined, b: ListAnnouncementsResponse | PlainMessage<ListAnnouncementsResponse> | undefined): boolean {
    return proto3.util.equals(ListAnnouncementsResponse, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.GetAnnouncementRequest
 */
export class GetAnnouncementRequest extends Message<GetAnnouncementRequest> {
  /**
   * @generated from field: string announcement_id = 1;
   */
  announcementId = "";

  constructor(data?: PartialMessage<GetAnnouncementRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.GetAnnouncementRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announcement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAnnouncementRequest {
    return new GetAnnouncementRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAnnouncementRequest {
    return new GetAnnouncementRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAnnouncementRequest {
    return new GetAnnouncementRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAnnouncementRequest | PlainMessage<GetAnnouncementRequest> | undefined, b: GetAnnouncementRequest | PlainMessage<GetAnnouncementRequest> | undefined): boolean {
    return proto3.util.equals(GetAnnouncementRequest, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.AnnouncementResponse
 */
export class AnnouncementResponse extends Message<AnnouncementResponse> {
  /**
   * @generated from field: vsmr.announcement.v1.Announcement announcement = 1;
   */
  announcement?: Announcement;

  constructor(data?: PartialMessage<AnnouncementResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.AnnouncementResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announcement", kind: "message", T: Announcement },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnnouncementResponse {
    return new AnnouncementResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnnouncementResponse {
    return new AnnouncementResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnnouncementResponse {
    return new AnnouncementResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AnnouncementResponse | PlainMessage<AnnouncementResponse> | undefined, b: AnnouncementResponse | PlainMessage<AnnouncementResponse> | undefined): boolean {
    return proto3.util.equals(AnnouncementResponse, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.CreateAnnouncementRequest
 */
export class CreateAnnouncementRequest extends Message<CreateAnnouncementRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string body = 2;
   */
  body = "";

  /**
   * 바로 게시할지, 초안으로 둘지
   *
   * @generated from field: bool published = 3;
   */
  published = false;

  constructor(data?: PartialMessage<CreateAnnouncementRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.CreateAnnouncementRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "published", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAnnouncementRequest {
    return new CreateAnnouncementRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAnnouncementRequest {
    return new CreateAnnouncementRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAnnouncementRequest {
    return new CreateAnnouncementRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAnnouncementRequest | PlainMessage<CreateAnnouncementRequest> | undefined, b: CreateAnnouncementRequest | PlainMessage<CreateAnnouncementRequest> | undefined): boolean {
    return proto3.util.equals(CreateAnnouncementRequest, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.UpdateAnnouncementRequest
 */
export class UpdateAnnouncementRequest extends Message<UpdateAnnouncementRequest> {
  /**
   * @generated from field: string announcement_id = 1;
   */
  announcementId = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string body = 3;
   */
  body = "";

  /**
   * @generated from field: bool published = 4;
   */
  published = false;

  constructor(data?: PartialMessage<UpdateAnnouncementRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.UpdateAnnouncementRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announcement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "published", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAnnouncementRequest {
    return new UpdateAnnouncementRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAnnouncementRequest {
    return new UpdateAnnouncementRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAnnouncementRequest {
    return new UpdateAnnouncementRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAnnouncementRequest | PlainMessage<UpdateAnnouncementRequest> | undefined, b: UpdateAnnouncementRequest | PlainMessage<UpdateAnnouncementRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAnnouncementRequest, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.DeleteAnnouncementRequest
 */
export class DeleteAnnouncementRequest extends Message<DeleteAnnouncementRequest> {
  /**
   * @generated from field: string announcement_id = 1;
   */
  announcementId = "";

  constructor(data?: PartialMessage<DeleteAnnouncementRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.DeleteAnnouncementRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announcement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAnnouncementRequest {
    return new DeleteAnnouncementRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAnnouncementRequest {
    return new DeleteAnnouncementRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAnnouncementRequest {
    return new DeleteAnnouncementRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAnnouncementRequest | PlainMessage<DeleteAnnouncementRequest> | undefined, b: DeleteAnnouncementRequest | PlainMessage<DeleteAnnouncementRequest> | undefined): boolean {
    return proto3.util.equals(DeleteAnnouncementRequest, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.DeleteAnnouncementResponse
 */
export class DeleteAnnouncementResponse extends Message<DeleteAnnouncementResponse> {
  /**
   * @generated from field: string announcement_id = 1;
   */
  announcementId = "";

  constructor(data?: PartialMessage<DeleteAnnouncementResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.DeleteAnnouncementResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announcement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAnnouncementResponse {
    return new DeleteAnnouncementResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAnnouncementResponse {
    return new DeleteAnnouncementResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAnnouncementResponse {
    return new DeleteAnnouncementResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAnnouncementResponse | PlainMessage<DeleteAnnouncementResponse> | undefined, b: DeleteAnnouncementResponse | PlainMessage<DeleteAnnouncementResponse> | undefined): boolean {
    return proto3.util.equals(DeleteAnnouncementResponse, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.MarkAnnouncementsReadRequest
 */
export class MarkAnnouncementsReadRequest extends Message<MarkAnnouncementsReadRequest> {
  /**
   * 여기까지 읽었다. 뒤로 가지 않는다 — 서버는 지금 값과 큰 쪽을 남긴다.
   * 게시된 번호를 넘는 값은 게시된 최댓값으로 자른다(아직 없는 번호를
   * 받아 두면 그 번호까지의 공지가 영영 읽음이 된다).
   *
   * @generated from field: int64 number = 1;
   */
  number = protoInt64.zero;

  constructor(data?: PartialMessage<MarkAnnouncementsReadRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.MarkAnnouncementsReadRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkAnnouncementsReadRequest {
    return new MarkAnnouncementsReadRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkAnnouncementsReadRequest {
    return new MarkAnnouncementsReadRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkAnnouncementsReadRequest {
    return new MarkAnnouncementsReadRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MarkAnnouncementsReadRequest | PlainMessage<MarkAnnouncementsReadRequest> | undefined, b: MarkAnnouncementsReadRequest | PlainMessage<MarkAnnouncementsReadRequest> | undefined): boolean {
    return proto3.util.equals(MarkAnnouncementsReadRequest, a, b);
  }
}

/**
 * @generated from message vsmr.announcement.v1.MarkAnnouncementsReadResponse
 */
export class MarkAnnouncementsReadResponse extends Message<MarkAnnouncementsReadResponse> {
  /**
   * @generated from field: int64 last_read_number = 1;
   */
  lastReadNumber = protoInt64.zero;

  /**
   * @generated from field: int32 unread_count = 2;
   */
  unreadCount = 0;

  constructor(data?: PartialMessage<MarkAnnouncementsReadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.announcement.v1.MarkAnnouncementsReadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "last_read_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "unread_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkAnnouncementsReadResponse {
    return new MarkAnnouncementsReadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkAnnouncementsReadResponse {
    return new MarkAnnouncementsReadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkAnnouncementsReadResponse {
    return new MarkAnnouncementsReadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MarkAnnouncementsReadResponse | PlainMessage<MarkAnnouncementsReadResponse> | undefined, b: MarkAnnouncementsReadResponse | PlainMessage<MarkAnnouncementsReadResponse> | undefined): boolean {
    return proto3.util.equals(MarkAnnouncementsReadResponse, a, b);
  }
}

